<template>
  <div class="comp">
    <el-dialog :visible.sync="dialogState" width="1580px" top="50px">
      <div style="
          display: flex;
          font-size: 18px;
          padding-bottom: 10px;
          padding-left: 10px; ">
        <span style="padding-right: 80px">会员名称：
          <span style="font-weight: bold" v-if="userInfo.basic_info">{{
            userInfo.basic_info.nick_name
          }}</span>
        </span>
        <span style="padding-right: 80px">会员卡：
          <span style="font-weight: bold" v-if="userInfo.club_card">{{
          userInfo.club_card.is_valid?'是':'否'
          }}</span>
        </span>
        <span style="padding-right: 80px">账户余额：
          <span style="font-weight: bold" v-if="userInfo.card_info">{{ userInfo.card_info.user_yue }} 元</span>
        </span>
        <span style="padding-right: 80px">宠物：
          <span style="font-weight: bold">{{ curPetInfo.nick_name }}</span>
        </span>
        <span style="padding-right: 80px">宠物权益：
          <span style="font-weight: bold">
            {{
              curPetInfo.hundred_assure &&
              curPetInfo.hundred_assure.status === 1
                ? "百天保障"
                : ""
            }}
            {{
              curPetInfo.medical_money && curPetInfo.medical_money.status === 1
                ? "万元医疗(剩余" + curPetInfo.medical_money.total_money + "元)"
                : ""
            }}
          </span>
        </span>
      </div>
      <div style="height: 650px; overflow-y: scroll; position: relative">
        <el-table :data="tableData" style="width: 100%; min-height: 650px" v-loading="tableData.length === 0" :empty-text="'加载中...'" @selection-change="changeSelection" ref="table">
          <el-table-column type="selection" :selectable="
              (row) => {
                return (
                  row.delPaid !== true &&
                  row.replaceType !== 2 &&
                  !(bingliMsg.payType === 1 && bingliMsg.alreadyPayMoney === 0)
                );
              }
            " width="50">
          </el-table-column>
          <el-table-column label="编号" width="50">
            <template slot-scope="props">
              {{ parseInt(props.$index + 1) }}
            </template>
          </el-table-column>
          <el-table-column label="名称" width="230" prop="goodsName">
          </el-table-column>
          <el-table-column label="规格" width="120" prop="skuValue">
          </el-table-column>
          <el-table-column label="标准价/会员价" width="120">

            <template slot-scope="props">
              <span>{{ props.row.originalPrice }} /{{ props.row.vipPrice>0?props.row.vipPrice:props.row.originalPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="70" prop="num">
          </el-table-column>
          <el-table-column label="单位" prop="unit" width="70">
          </el-table-column>
          <el-table-column label="活动" width="155">
            <template slot="header">
              活动
              <img style="width: 18px; vertical-align: sub; cursor: pointer" src="../assets/img/refresh.png" @click="refreshActivityList" />
            </template>
            <template slot-scope="scope">
              <!-- !$public.isNull(scope.row.couponId)|| -->
              <el-select v-model="scope.row.activityId" :disabled="
                  scope.row.notCount === true ||
                  scope.row.delPaid ||
                  !scope.row.canActivity ||
                  discountCard !== null
                " @change="changeActivityId(scope.row)" placeholder="请选择" size="mini" style="width: 130px" clearable>
                <el-option v-for="item in scope.row.activityList" :key="item._id" :label="item.name" :value="item._id" :disabled="
                    !$public.calcActivity(
                      item,
                      $public.cheng(scope.row.originalPrice, scope.row.num),
                      scope.row.num
                    ).state
                  "></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- <el-table-column label="优惠券" prop="price">
            <template slot-scope="scope">
              <el-select
              clearable
              :disabled="!$public.isNull(scope.row.activityId)"
                v-model="scope.row.couponId"
                filterable
                placeholder="请选择"
                size="small"
                style="width: 150px"
                @change="changeCoupon(scope.row.couponId, scope.row.couponList)"
              >
                <el-option
                  v-for="item in scope.row.couponList"
                  :key="item._no"
                  :label="item.coupon_name + '(' + item._no + ')'"
                  :value="item._no"
                ></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column label="优惠价" width="70" prop="price">
          </el-table-column>
          <el-table-column label="用量" width="80" prop="goodsDosage">
          </el-table-column>
          <el-table-column label="用法" width="80" prop="goodsUsage">
            <template slot-scope="props">
              <span v-if="
                  !$public.isNull(props.row.goodsUsage) &&
                  props.row.goodsUsage.length === 5
                ">
                {{ props.row.goodsUsage[0] }} {{ props.row.goodsUsage[1] }}天{{
                  props.row.goodsUsage[2]
                }}次 每次{{ props.row.goodsUsage[3]
                }}{{ props.row.goodsUsage[4] }}
              </span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="70" prop="remark">
          </el-table-column>
          <el-table-column label="小计" width="90">
            <template slot-scope="props">
              <div v-if="props.row.price < 0">{{ props.row.price }}</div>
              <div v-else>{{ $public.getSubtotal(props.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售人员" width="120">
            <template slot-scope="scope">
              <!-- <div>{{ scope.row.replaceMark }}</div> -->
              <el-select v-model="scope.row.staff" @change="changeStaff(scope.row)" multiple filterable placeholder="请选择" size="mini">
                <el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name" :value="item._id + ',' + item.basic_info.nick_name"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="payLine">
        <div class="payLineL" style="display: flex;">
          <span class="text">
            总计：￥<b style="font-size: 26px">{{ total }}</b>
          </span>
          <span class="text" style="color: #1da900" v-show="
              delPaid > 0 && tableData[0] && tableData[0].notCount === false
            ">
            已支付：￥<b style="font-size: 26px">{{ delPaid }}</b>
          </span>
          <span class="text" style="margin-right: 50px">
            优惠金额：
            <el-popover placement="top-start" title="" trigger="hover">
              <div>
                <div>百天保障抵扣：{{ BT }}</div>
                <div>万元医疗抵扣：{{ WY }}</div>
              </div>
              <span slot="reference">￥<b style="font-size: 26px; color: #1890ff">{{
                  reduceTotal
                }}</b></span>
            </el-popover>
          </span>
          <div class="text">
            会员价：￥<b style="font-size: 26px">{{ vipTotal }}</b>
          </div>
          <el-button style="width: 110px" type="primary" plain @click="delDiscountCard" v-if="discountCard && discountCard._id">取消优惠券</el-button>
          <el-button style="width: 80px" type="primary" plain @click="openDiscountCard" v-else>优惠券</el-button>
        </div>
        <div class="payLineR" style="display: flex;">
          <!-- <span class="text" style="color: red">
            应付金额：￥<b style="font-size: 26px; font-weight: bold">{{
              activityTotal
            }}</b>
          </span> -->
          <el-button v-if="userInfo.club_card&&userInfo.club_card.is_valid==false&&userInfo.card_info.user_yue>0&&showVip==true" :disabled="vipTotal>userInfo.card_info.user_yue||total==vipTotal" class="btn"
            style="background-color: #1890FF;border: none" @click="submit('saveOrder',1)">
            <img class="img" src="../assets/img/saveOrder.png" />会员价支付 ￥{{ vipTotal }}
          </el-button>
          <div class="btn" style="background-color: #F5882A" @click="submit('saveOrder')">
            <img class="img" src="../assets/img/saveOrder.png" />保存订单并支付 ￥{{
              activityTotal
            }}
          </div>
          <!-- <div
            class="btn"
            style="background-color: #fd4e4e"
            @click="submit('')"
          >
            <img class="img" src="../assets/img/saveOrder.png" />保存订单
          </div> -->
        </div>
      </div>
    </el-dialog>
    <div v-if="yiliao_state">
      <dialogYiLiao :orderId="orderId" :activityTotal="activityTotal" :orderNum="curOrder.no" @submit="submityiLiao"></dialogYiLiao>
    </div>
    <dialogQRCode v-if="dialogPayState" :QRCode="codeUrl" :orderNum="curOrder.no" @submit="dialogPaySubmit"></dialogQRCode>
    <!-- 优惠券 -->
    <div v-show="drawerDiscountCard_state">
      <drawerDiscountCard :userId="bingliMsg.memberId" :state="drawerDiscountCard_state" :money="activityTotal" :type="discountType" @submit="submit_drawerDiscountCard"></drawerDiscountCard>
    </div>
  </div>
</template>
<script>
import dialogYiLiao from "./dialog_yiliao.vue";
import dialogQRCode from "./dialogQRCode.vue";
// 获取用户可用优惠券
import {
  getetMemberCanUseCoupon,
  getallMemberCanUseCoupon,
} from "@/api/newCoupon.js";
import drawerDiscountCard from "../views/mendian/shouyin/drawer/discountximeiCard.vue";
export default {
  components: { dialogQRCode, drawerDiscountCard, dialogYiLiao },
  data() {
    return {
      // 可用优惠券
      couPonList: [],
      couNOsArr: [],
      orderId: "",
      yiliao_state: false,
      dialogState: true,
      dialogPayState: false,
      staffList: [],
      tableData: [],
      tableData_discountCard: [],
      userInfo: {},
      curPetInfo: {},
      total: 0,
      vipTotal: 0,
      showVip:false,
      activityTotal: 0,
      reduceTotal: 0,
      codeUrl: "", // 二维码地址
      curOrder: "",
      selection: [], // 选中的条目
      discountCard: null,
      // 优惠券
      drawerDiscountCard_state: false,
      discountType: 3,
      // 病例万元百天
      BT: 0,
      WY: 0,
    };
  },
  computed: {
    shopId() {
      return this.$store.state.shopId;
    },
  },
  props: {
    type: {
      // 0 病例  1 疫苗驱虫   2 医疗套餐
      default: 0,
    },
    delPaid: {
      default: 0,
    },
    bingliMsg: {
      default: () => {
        return {};
      },
    },
    selectedArr: {
      default: () => {
        return [];
      },
    },
  },
  watch: {
    dialogState(n) {
      this.$emit("close", n);
    },
  },
  created() {},
  mounted() {
    console.log(this.selectedArr,'selectedArr11');
    this.change();
  },
  methods: {
    // 改变优惠券
    changeCoupon(id, arr) {
      // couNOsArr
      this.couNOsArr.push(id);
      // if (this.couNOsArr.length) {
      //   this.couNOsArr.forEach((item) => {
      //     if (item == id) {
      //       console.log("qingcongxin ");
      //     }
      //   });
      // }
      console.log("ID", id);
      console.log("arr", arr);
    },
    change() {
      if (this.type === 0) {
        this.discountType = 3;
      } else if (this.type === 1) {
        this.discountType = 4;
      } else if (this.type === 2) {
        this.discountType = 5;
      }

      this.$util.getStaffList().then((list) => {
        this.staffList = list;
      });
      let staff = [];
      this.$store.state.yiliaoxin.userController.map((controller) => {
        if (controller.invitationType === 3 && controller.userId.length > 0) {
          this.staff = [controller.userId + "," + controller.userName];
        }
      });

      this.$util.getUserInfo(this.bingliMsg.memberId).then((res) => {
        this.userInfo = res;
        this.tableData = JSON.parse(JSON.stringify(this.selectedArr));
        // for (var i = 0; i < this.tableData.length; i++) {
        //   this.tableData[i].couponList = this.couPonList[i].couPonList;
        // }
        this.tableData_discountCard = JSON.parse(
          JSON.stringify(this.selectedArr)
        );
        if (this.delPaid > 0) {
         console.log(111111);
          this.tableData.push({
            goodsId: "607d376f4f7236998724673f",
            goodsName: "医疗抵扣支付价格",
            originalPrice: -this.delPaid,
            price: -this.delPaid,
            num: 1,
            unit: "次",
            delPaid: true,
            goodsType: 4,
            skus: "",
            skuValue: "",
            model: "",
            activityId: "",
            activityItem: {},
            totalMoney: "",
            goodsSalesModel: 1, //  1：正常销售；2：赠品
            goodsList: [],
            staff: staff,
          });
        }
        if (this.type === 0) {
          for (let i = 0; i < this.userInfo.pets_info.length; i++) {
            if (this.userInfo.pets_info[i]._id === this.bingliMsg.petId) {
              this.curPetInfo = this.userInfo.pets_info[i];
            }
          }
        }
        this.$nextTick(() => {
          for (let i = 0; i < this.tableData.length; i++) {
            this.$refs["table"].toggleRowSelection(this.tableData[i], true);
            this.tableData[i].index = i;
            this.tableData[i].originalPrice = this.tableData[i].price;
            if(this.userInfo.club_card.is_valid&&this.tableData[i].vipPrice>0&&this.$public.isNull(this.tableData[i].activityId)){
              this.tableData[i].price = this.tableData[i].vipPrice;
            }
            this.tableData[i].activityId = "";
            this.tableData[i].activityItem = {};
            if (this.tableData[i].notCount === true) {
              this.tableData[i].price = 0;
            }
          }
          this.getTotal();
          this.getActivityListByArr(this.tableData, -1);
        });
      });
    },
    async getUserCon(arr) {
      // let bigConponArr = [];
      for (var i = 0; i < arr.length; i++) {
        let obj = {
          member_id: this.bingliMsg.memberId,
          money: arr[i].totalMoney,
          category_id: arr[i].categoryId,
          goods_id: arr[i].goodsId,
          use_scene: 2,
          // sku_id:arr[i].goodsType==4?arr[i].goodsId:'',
        };
        let res = await getetMemberCanUseCoupon(obj);
        this.couPonList.push({ couPonList: res.data });
      }
      // this.change();
    },
    submityiLiao() {
      this.yiliao_state = false;
      this.$emit("close", {});

    },
    submitCard(card) {
      if (card !== "close") {
        this.discountCard = card;
        this.getTotal();
      }
    },
    // 二维码提交
    dialogPaySubmit(str) {
      this.dialogPayState = false;
      if (str == "success") {
        this.$emit("submit");
      } else if (str == "close") {
        this.$emit("submit");
      }
    },
    // 改变销售人员
    changeStaff(row) {
      if (row.index == 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].staff = this.tableData[0].staff;
        }
      }
    },
    submit(str, type) {
      if (
        this.curPetInfo.medical_money &&
        this.curPetInfo.medical_money.status === 1
      ) {
        if (this.WY > this.curPetInfo.medical_money.total_money) {
          this.$message({
            message: "万元医疗余额不足！",
            type: "error",
          });
          return;
        }
      }
      let loading = this.$loading();
      if (this.codeUrl && str === "scan") {
        this.dialogPayState = true;
        loading.close();
        return;
      }
      let noStaff = false;
      let orderGoods = [];
      for (let i = 0; i < this.selection.length; i++) {
        let salesMans = [];
        if (this.selection[i].staff.length == 0) {
          if (this.$public.isNull(this.selection[i].replaceMark)) {
            noStaff = true;
          }
        } else {
          for (let q = 0; q < this.selection[i].staff.length; q++) {
            salesMans.push({
              userId: this.selection[i].staff[q].split(",")[0],
              userName: this.selection[i].staff[q].split(",")[1],
            });
          }
        }
        orderGoods.push({
          itemsId: this.selection[i].delPaid
            ? "delPaid"
            : this.selection[i].itemsId,
          brand: this.selection[i].brand,
          categoryId: this.selection[i].categoryId,
          categoryName: this.selection[i].categoryName,
          goodsId: this.selection[i].goodsId,
          goodsName: this.selection[i].goodsName,
          isHumanMedication: this.selection[i].isHumanMedication,
          otherName: this.selection[i].otherName,
          goodsType: this.selection[i].goodsType,
          skus: this.selection[i].skus,
          skuValue: this.selection[i].skuValue,
          model: this.selection[i].model,
          unit: this.selection[i].unit,
          outUnit:this.selection[i].outUnit,
          allowWholesale: this.selection[i].allow_wholesale?this.selection[i].allow_wholesale:this.selection[i].allowWholesale,
          dosageCeiling: this.selection[i].dosageCeiling,
          dosageCeilingValue: this.selection[i].dosageCeilingValue,
          goodsDosage: this.selection[i].goodsDosage,
          originalPrice: this.selection[i].originalPrice,
          price: this.selection[i].price,
          num: this.selection[i].num,
          vipPrice: this.selection[i].vipPrice,
          activityId: this.selection[i].activityId,
          activityName: this.selection[i].activityItem.name,
          payType: this.selection[i].activityItem.pay_type,
          totalMoney:
            this.selection[i].price < 0
              ? this.selection[i].price
              : this.$public.cheng(
                  this.selection[i].price,
                  this.selection[i].num
                ),
          goodsSalesModel: 1, //  1：正常销售；2：赠品
          notCount: this.selection[i].notCount,
          goodsList: [],
          salesMans: salesMans,
          buyBack: this.selection[i].buyBack,
          replaceMark: this.selection[i].replaceMark,
        });
      }
      if (noStaff) {
        this.$message({
          message: "请完善销售人员",
          type: "error",
        });
        loading.close();
        return;
      }
      let params = {
        medicalRecordId: this.bingliMsg.caseNumber || this.bingliMsg.id,
        memberId: this.bingliMsg.memberId,
        memberName: this.bingliMsg.memberName,
        memberMobile: this.bingliMsg.memberMobile,
        petId: this.bingliMsg.petId,
        petName: this.bingliMsg.petName,
        totalMoney: this.total,
        discountMoney: this.reduceTotal,
        remark: this.bingliMsg.remark,
        orderGoods: orderGoods,
        useVipPrice: type == 1 ? true : false,
        coupon_no: this.discountCard !== null ? this.discountCard._no : "",
      };
      let url = ""; // 0 病例  1 疫苗驱虫   2 医疗套餐
      if (this.type === 0) {
        url = "/api/Order/CreateCaseOrder";
      } else if (this.type === 1) {
        url = "/api/Order/CreateVaccineOrder";
      } else if (this.type === 2) {
        url = "/api/Order/CreateMedicalGroupOrder";
      }
      this.$http.post(url, params).then((res) => {
        if (res.code == 0) {
          this.discountCard = null;
          this.curOrder = res.data;
          if (str == "scan") {
            this.getPayAddr();
          } else if (str == "jialianScan") {
            this.getPayAddrJialian();
          } else if (str == "saveOrder") {
            this.orderId = res.data._id;
            if (this.activityTotal > 0) {
              this.$message({
                message: "保存订单成功",
                type: "success",
              });
              this.yiliao_state = true;
            }
            loading.close();
          } else {
            if (this.activityTotal > 0) {
              this.$emit("submit");
              this.$message({
                message: "保存订单成功",
                type: "success",
              });
              loading.close();
            } else {
              loading.close();
              this.$confirm(
                "操作成功。生成的订单金额为0，是否自动支付?",
                "提醒",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success",
                }
              )
                .then(() => {
                  let params = {
                    order_id: res.data._id, // 订单记录id
                    order_no: res.data.no, // 订单号
                    pay_Info: {
                      pay_remark: "0元医生自动支付",
                      payment_no: "", // 支付流水号
                      pay_list: [{ pay_type: 0, money: 0 }],
                    },
                  };
                  let loading = this.$loading();
                  this.$http.post("/api/Order/PayOrder", params).then((res) => {
                    loading.close();
                    if (res.code == 0) {
                      this.$emit("submit");
                    }
                  });
                })
                .catch(() => {
                  this.$emit("submit");
                });
            }
          }
        } else {
          loading.close();
        }
      });
    },
    // 获取支付地址
    getPayAddr() {
      let loading = this.$loading();
      this.$http
        .get("/api/Pay/ScanPayOrder", { orderNum: this.curOrder.no })
        .then((res) => {
          if (res.code == 0) {
            this.codeUrl = res.data.codeUrl;
            this.dialogPayState = true;
            loading.close();
          } else {
            loading.close();
          }
        });
    },
    getPayAddrJialian() {
      let loading = this.$loading();
      this.$http
        .get("/api/Pay/JL/ScanPayOrder", { orderNum: this.curOrder.no })
        .then((res) => {
          if (res.code == 0) {
            this.codeUrl = res.data.codeUrl;
            this.dialogPayState = true;
            loading.close();
          } else {
            loading.close();
          }
        });
    },
    /////////////////////////////    活动    //////////////////////////
    refreshActivityList() {
      if (this.tableData.length > 0) {
        this.getActivityListByArr(this.tableData, -1);
      }
    },
    changeActivityId(row) {
      if (this.$public.isNull(row.activityId)) {
        if (
          this.userInfo.club_card &&
          this.userInfo.club_card.is_valid == true &&
          row.vipPrice > 0
        ) {
          row.price = row.vipPrice;
        } else {
          row.price = row.originalPrice;
        }
        row.activityItem = {};
        row.giftList = [];
        // this.o.init(this.tableData)
      } else {
        row.activityItem = {};
        row.giftList = [];
        let activityItem = this.$public.getMatchingItem(
          row.activityList,
          "_id",
          row.activityId
        );
        let calcResult = this.$public.calcActivity(
          activityItem,
          this.$public.cheng(row.originalPrice, row.num),
          row.num
        );
        console.log(calcResult);
        row.price = this.$public.chu(calcResult.newPrice, row.num);
        row.activityItem = activityItem;
        // if(!this.$public.isNull(calcResult.gift.give_list)){
        // 	this.curIndex = row.index;
        // 	this.giveGoods = calcResult.gift;
        // 	this.drawerGift_state = true;
        // }
      }
      // this.$store.commit('mendian/set_saleList',this.tableData)
      this.tableData_discountCard = JSON.parse(JSON.stringify(this.selection));
      this.getTotal();
    },
    getActivityListByArr(arr, index) {
      console.log(arr, index);
      this.$util
        .getActivityOfProduct(this.userInfo, arr, this.curPetInfo)
        .then((res) => {
          for (let i = 0; i < arr.length; i++) {
            let arrItem = arr[i];
            arrItem.activityList = res[i].list;
            if (
              !this.$public.isNull(res[i].list) &&
              res[i].list[0].auto_matching > 0
            ) {
              if (
                this.$public.isNull(this.discountCard && this.discountCard._no)
              ) {
                if (
                  arrItem.notCount === false &&
                  !arrItem.delPaid &&
                  !!arrItem.canActivity
                ) {
                  arrItem.activityId = res[i].list[0]._id;
                  arrItem.activityItem = res[i].list[0];
                  let calcResult = this.$public.calcActivity(
                    arrItem.activityItem,
                    this.$public.cheng(arrItem.originalPrice, arrItem.num),
                    arrItem.num
                  );
                  console.log(calcResult);
                  arrItem.price = this.$public.chu(
                    calcResult.newPrice,
                    arrItem.num
                  );
                }
              }
            }
            this.$set(arr, i, arrItem);
          }
          this.tableData_discountCard = JSON.parse(
            JSON.stringify(this.selection)
          );
          this.getTotal();
        });
    },
    // selection-change
    changeSelection() {
      this.getTotal();
      this.tableData_discountCard = JSON.parse(JSON.stringify(this.selection));
    },
    getTotal() {
      let arr = (this.selection = this.$refs.table.selection);
      console.log(arr,'arr1');
      let total = 0,
        activityTotal = 0,
        vipTotal = 0,
        showVip = false;
      this.BT = 0;
      this.WY = 0;

      for (let i = 0; i < arr.length; i++) {
        //是否使用会员价
        let useVipPrice = false;
        
        if (arr[i].activityId == "" && arr[i].vipPrice > 0) {
          console.log('用了活动并且会员价大于0');
          useVipPrice = true;
          showVip=true;
        }
        // 最小单位出库
        if (arr[i].allow_wholesale === 0 || arr[i].allowWholesale === 0) {
          if (arr[i].price < 0) {
            let t = arr[i].price;
            total = this.$public.jian(total, Math.abs(t));
            let t1 = arr[i].price;
            activityTotal = this.$public.jian(activityTotal, Math.abs(t1));
          } else {
            console.log(arr[i].countPriceDosage,arr[i].originalPrice,'???????');
            let t = this.$public.cheng(
              arr[i].countPriceDosage,
              arr[i].originalPrice
            );
            total = this.$public.jia(total, t);
            let t1 = this.$public.cheng(arr[i].countPriceDosage, arr[i].price);
            activityTotal = this.$public.jia(activityTotal, t1);
console.log(useVipPrice,'检测是否是会员');
            if (useVipPrice) {
              let t2 = this.$public.cheng(
                arr[i].countPriceDosage,
                arr[i].vipPrice
              );
              vipTotal = this.$public.jia(vipTotal, t2);
            } else {
              let t2 = this.$public.cheng(
                arr[i].countPriceDosage,
                arr[i].price
              );
              vipTotal = this.$public.jia(vipTotal, t2);
            }
          }
        } else {
          if (arr[i].price < 0) {
            let t = arr[i].price;
            total = this.$public.jian(total, Math.abs(t));
            let t1 = arr[i].price;
            activityTotal = this.$public.jian(activityTotal, Math.abs(t1));
          } else {
            console.log(arr[i].num,arr[i].originalPrice,'！！！！！！');
            let t = this.$public.cheng(arr[i].num, arr[i].originalPrice);
            total = this.$public.jia(total, t);
            let t1 = this.$public.cheng(arr[i].num, arr[i].price);
            activityTotal = this.$public.jia(activityTotal, t1);
            if (useVipPrice) {
              let t2 = this.$public.cheng(
                arr[i].num,
                arr[i].vipPrice
              );
              vipTotal = this.$public.jia(vipTotal, t2);
            } else {
              let t2 = this.$public.cheng(
                arr[i].num,
                arr[i].price
              );
              vipTotal = this.$public.jia(vipTotal, t2);
            }
          }
        }
        if (this.type === 0) {
          // 60b4ac497a5b40600349824e 百天保障      60b4acda7a5b40600349826a 万元医疗
          if (arr[i].activityId === "60b4ac497a5b40600349824e") {
            this.BT = this.$public.jia(
              this.BT,
              this.$public.jian(
                this.$public.getSubtotal(arr[i], true),
                this.$public.getSubtotal(arr[i])
              )
            );
          } else if (arr[i].activityId === "60b4acda7a5b40600349826a") {
            this.WY = this.$public.jia(
              this.WY,
              this.$public.jian(
                this.$public.getSubtotal(arr[i], true),
                this.$public.getSubtotal(arr[i])
              )
            );
          }
        }
        console.log("是否展示会员价支付得到状态",showVip);
      }
      this.showVip = showVip;
      this.total = total;
      this.vipTotal = vipTotal;
      console.log(this.discountCard, "this.discountCardthis.discountCard");
      if (this.discountCard !== null) {
        if (this.discountCard.activity_type === 1) {
          // 满减
          this.activityTotal = this.$public.jian(
            activityTotal,
            this.discountCard.money_reduce
          );
        } else if (this.discountCard.activity_type === 2) {
          // 折扣
          let yh = this.$public.cheng(
            activityTotal,
            this.$public.jian(1, this.discountCard.rebate)
          );
          if (this.discountCard.rebate_limit > 0) {
            if (yh > this.discountCard.rebate_limit) {
              yh = this.discountCard.rebate_limit;
            }
          }
          this.activityTotal = this.$public.jian(activityTotal, yh);
        }
      } else {
        this.activityTotal = activityTotal;
      }
      this.reduceTotal = this.$public.jian(total, this.activityTotal); // 优惠金额
    },
    // 优惠券
    openDiscountCard() {
      if (this.type === 0) {
        console.log("病例");
      } else if (this.type === 1) {
        this.$message({
          message: "疫苗驱虫不可使用优惠券！！",
          type: "error",
        });
        return;
      } else if (this.type === 2) {
        this.$message({
          message: "医疗服务不可使用优惠券！！",
          type: "error",
        });
        return;
      }
      let canCard = true;
      for (let i = 0; i < this.tableData_discountCard.length; i++) {
        // 60b4ac497a5b40600349824e 百天保障      60b4acda7a5b40600349826a 万元医疗
        if (
          this.tableData_discountCard[i].activityId ===
            "60b4ac497a5b40600349824e" ||
          this.tableData_discountCard[i].activityId ===
            "60b4acda7a5b40600349826a"
        ) {
          this.$message({
            message: "参与百天保障或万元医疗的宠物不可使用优惠券！！",
            type: "error",
          });
          return;
        }
        if (!this.$public.isNull(this.tableData_discountCard[i].activityId)) {
          canCard = false;
        }
      }
      if (canCard === false) {
        this.$message({
          message: "选择活动后不可使用优惠券！！",
          type: "error",
        });
      } else {
        this.drawerDiscountCard_state = true;
      }
    },
    submit_drawerDiscountCard(obj) {
      if (obj.type === "submit") {
        this.activityTotal = obj.newMoney;
        this.discountCard = obj.card;
        this.drawerDiscountCard_state = false;
        this.getTotal();
      } else {
        this.drawerDiscountCard_state = false;
      }
    },
    delDiscountCard() {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.activityTotal = this.total;
        this.discountCard = null;
        this.getTotal();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.comp {
  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }
  .payLine {
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    .payLineL {
      .text {
        font-size: 16px;
        line-height: 48px;
        margin-right: 30px;
      }
    }
    .payLineR {
      .text {
        font-size: 16px;
        margin-right: 30px;
      }
      .btn {
        display: inline-block;
        color: white;
        height: 50px;
        padding: 0 20px;
        border-radius: 4px;
        text-align: center;
        line-height: 48px;
        margin-right: 35px;
        cursor: pointer;
        .img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
          vertical-align: sub;
        }
      }
    }
  }
}
</style>
